var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"name"},[_c('div',{staticClass:"tag",class:[!_vm.disable ? '' : 'canceled'],style:({
      background: _vm.color,
      color: _vm.textColor
    }),attrs:{"title":_vm.entry.name}},[_vm._v(" "+_vm._s(_vm.entry.short_name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }